export enum ProjectStatusEnum {
  init = 'init',
  started = 'started',
  active = 'active',
  finished = 'finished'
}
